<script lang="ts">
	import P from "#lib/components/P.svelte";
</script>

<P size="sm" align="center"><span class="font-semibold">Click to upload</span><br />or drag and drop</P>
